export default __webpack_public_path__ + "static/media/activity-3.8d52fd5e.png";